import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import i18n from "@/config/i18n";
import { piThConvertStringToTimes } from "@/utils/time.helper";
let PiFeeDetailsChildDelayRateTable = class PiFeeDetailsChildDelayRateTable extends Vue {
    getTableColumns(type) {
        let text = type == "ac"
            ? i18n.t("delayFeeManage.acRateDetails") + ""
            : i18n.t("delayFeeManage.dcRateDetails") + "";
        return [
            {
                title: text,
                align: "center",
                children: [
                    {
                        title: i18n.t("pileInfoEle.time"),
                        key: "time",
                        slot: "time",
                        minWidth: 110,
                        align: "center",
                    },
                    {
                        title: i18n.t("pileInfoEle.slotDelayPrice"),
                        key: "slotDelayPrice",
                        minWidth: 130,
                        ...this.$config.tablePrice,
                    },
                    {
                        title: i18n.t("pileInfoEle.delayFreeMinutes"),
                        key: "freeMinutes",
                        minWidth: 130,
                        ...this.$config.tablePrice,
                    },
                    {
                        title: i18n.t("delayFeeManage.delayFeeUpperLimit"),
                        key: "delayFeeUpperLimit",
                        minWidth: 130,
                        ...this.$config.tablePrice,
                    },
                ],
            },
        ];
    }
    getTime(row) {
        if (row.time) {
            // 已经转过的直接显示
            return row.time;
        }
        else {
            return (piThConvertStringToTimes(row.beginTime) +
                "-" +
                piThConvertStringToTimes(row.endTime));
        }
    }
    /**
     * 交流全并单元格
     */
    acHandleSpan({ columnIndex, rowIndex }) {
        if ((rowIndex == 0 && columnIndex == 3) ||
            (rowIndex == 0 && columnIndex == 2)) {
            return {
                rowspan: this.acTableList.length,
                colspan: 1,
            };
        }
        else if ((rowIndex > 0 && columnIndex == 3) ||
            (rowIndex > 0 && columnIndex == 2)) {
            return {
                rowspan: 0,
                colspan: 0,
            };
        }
    }
    /**
     * 直流全并单元格
     */
    dcHandleSpan({ columnIndex, rowIndex }) {
        if ((rowIndex == 0 && columnIndex == 3) ||
            (rowIndex == 0 && columnIndex == 2)) {
            return {
                rowspan: this.dcTableList.length,
                colspan: 1,
            };
        }
        else if ((rowIndex > 0 && columnIndex == 3) ||
            (rowIndex > 0 && columnIndex == 2)) {
            return {
                rowspan: 0,
                colspan: 0,
            };
        }
    }
};
__decorate([
    Prop({
        default: () => {
            return [];
        },
    })
], PiFeeDetailsChildDelayRateTable.prototype, "acTableList", void 0);
__decorate([
    Prop({
        default: () => {
            return [];
        },
    })
], PiFeeDetailsChildDelayRateTable.prototype, "dcTableList", void 0);
__decorate([
    Prop({ default: "" })
], PiFeeDetailsChildDelayRateTable.prototype, "cardTitle", void 0);
__decorate([
    Prop({ default: false })
], PiFeeDetailsChildDelayRateTable.prototype, "loading", void 0);
PiFeeDetailsChildDelayRateTable = __decorate([
    Component({
        components: {},
    })
], PiFeeDetailsChildDelayRateTable);
export default PiFeeDetailsChildDelayRateTable;
